import { render, staticRenderFns } from "./PlanItemButton.vue?vue&type=template&id=504782dc&scoped=true"
import script from "./PlanItemButton.vue?vue&type=script&lang=js"
export * from "./PlanItemButton.vue?vue&type=script&lang=js"
import style0 from "./PlanItemButton.vue?vue&type=style&index=0&id=504782dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504782dc",
  null
  
)

export default component.exports